import usePermissions from "hooks/usePermissions";
const useCanEditSecurityEvent = (securityEventId) => {
  const { isPermitted } = usePermissions();
  return isPermitted(`security_event:edit:${securityEventId}`);
};
export default useCanEditSecurityEvent;
